import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles'
import { Row, Col, Grid } from 'flexbox'


class Box extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render() {
    return (
      <Grid fluid>
        <div className="box">
          <div className="box-header">
            <h2 className="box-title">{this.props.title}</h2>
          </div>
          <div className="box-content">
            {this.props.children}
          </div>
        </div>
        <style jsx> {styles} </style>
      </Grid>
      
    );
  }

}

export default Box
